module.exports = __webpack_public_path__ + "static/media/kele.8c5ebf9e.png";